import { pgTable, text, timestamp, integer, varchar } from 'drizzle-orm/pg-core';

// Таблица ролей с массивом прав
export const role = pgTable('Role', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  displayName: varchar({ length: 100 }).notNull(),
  description: text(),
  permissions: text().array().default([""]).notNull(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).defaultNow().notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
});

